type Referral = { label: string; value: string }

export const REFERRAL_TYPES: Array<Referral> = [
  { label: 'LinkedIn - Paro recruiter', value: 'LINKEDIN_RECRUITER' },
  { label: 'LinkedIn - Post', value: 'LINKEDIN_POST' },
  { label: 'Google', value: 'GOOGLE' },
  { label: 'Bing', value: 'BING' },
  { label: 'Blog Post', value: 'BLOG_POST' },
  { label: 'Built In', value: 'BUILT_IN' },
  { label: 'Contacted directly by a Paro recruiter', value: 'CONTACTED_DIRECTLY_BY_A_PARO_RECRUITER' },
  { label: 'Indeed', value: 'INDEED' },
  { label: 'Craigslist', value: 'CRAIGSLIST' },
  { label: 'Online Ad', value: 'ONLINE_AD' },
  { label: 'Referral', value: 'REFERRAL' },
  { label: 'Other', value: 'OTHER' },
]

export const FURLOUGH_CODE_OPTIONS: { label: string; value: string }[] = [
  { label: '3M', value: 'join-paro-3m' },
  {
    label: 'A-Mark Precious Metals',
    value: 'join-paro-a-mark-precious-metals',
  },
  { label: 'A.O. Smith', value: 'join-paro-a-o-smith' },
  { label: "Aaron's", value: 'join-paro-aarons' },
  { label: 'Abbott Laboratories', value: 'join-paro-abbott-laboratories' },
  { label: 'AbbVie', value: 'join-paro-abbvie' },
  { label: 'Abercrombie & Fitch', value: 'join-paro-abercrombie-fitch' },
  { label: 'ABM Industries', value: 'join-paro-abm-industries' },
  { label: 'Acadia Healthcare', value: 'join-paro-acadia-healthcare' },
  { label: 'Activision Blizzard', value: 'join-paro-activision-blizzard' },
  { label: 'Accounting Today', value: 'join-paro-accounting-today' },
  { label: 'Accounting Today CAS Summit 2022', value: 'join-paro-accounting-today-cas-summit-2022' },
  { label: 'Acuity Brands', value: 'join-paro-acuity-brands' },
  { label: 'Adobe', value: 'join-paro-adobe' },
  { label: 'ADP', value: 'join-paro-adp' },
  { label: 'ADT', value: 'join-paro-adt' },
  { label: 'Advance Auto Parts', value: 'join-paro-advance-auto-parts' },
  {
    label: 'Advanced Micro Devices',
    value: 'join-paro-advanced-micro-devices',
  },
  { label: 'AECOM', value: 'join-paro-aecom' },
  { label: 'AES', value: 'join-paro-aes' },
  {
    label: 'Affiliated Managers Group',
    value: 'join-paro-affiliated-managers-group',
  },
  { label: 'Aflac', value: 'join-paro-aflac' },
  { label: 'AGCO', value: 'join-paro-agco' },
  { label: 'Agilent Technologies', value: 'join-paro-agilent-technologies' },
  { label: 'AIG', value: 'join-paro-aig' },
  {
    label: 'Air Products & Chemicals',
    value: 'join-paro-air-products-chemicals',
  },
  { label: 'AK Steel Holding', value: 'join-paro-ak-steel-holding' },
  { label: 'Akamai Technologies', value: 'join-paro-akamai-technologies' },
  { label: 'Alaska Air Group', value: 'join-paro-alaska-air-group' },
  { label: 'Albemarle', value: 'join-paro-albemarle' },
  { label: 'Albertsons', value: 'join-paro-albertsons' },
  { label: 'Alcoa', value: 'join-paro-alcoa' },
  { label: 'Aleris', value: 'join-paro-aleris' },
  {
    label: 'Alexion Pharmaceuticals',
    value: 'join-paro-alexion-pharmaceuticals',
  },
  { label: 'Align Technology', value: 'join-paro-align-technology' },
  { label: 'Alleghany', value: 'join-paro-alleghany' },
  {
    label: 'Allegheny Technologies',
    value: 'join-paro-allegheny-technologies',
  },
  {
    label: 'Alliance Data Systems',
    value: 'join-paro-alliance-data-systems',
  },
  {
    label: 'Alliance Resource Partners',
    value: 'join-paro-alliance-resource-partners',
  },
  { label: 'Alliant Energy', value: 'join-paro-alliant-energy' },
  {
    label: 'Allison Transmission Holdings',
    value: 'join-paro-allison-transmission-holdings',
  },
  {
    label: 'Allscripts Healthcare Solutions',
    value: 'join-paro-allscripts-healthcare-solutions',
  },
  { label: 'Allstate', value: 'join-paro-allstate' },
  { label: 'Ally Financial', value: 'join-paro-ally-financial' },
  { label: 'Alphabet', value: 'join-paro-alphabet' },
  { label: 'Altice USA', value: 'join-paro-altice-usa' },
  { label: 'Altria Group', value: 'join-paro-altria-group' },
  { label: 'Amazon.com', value: 'join-paro-amazon-com' },
  { label: 'AMC Networks', value: 'join-paro-amc-networks' },
  { label: 'Amerco', value: 'join-paro-amerco' },
  { label: 'Ameren', value: 'join-paro-ameren' },
  {
    label: 'American Airlines Group',
    value: 'join-paro-american-airlines-group',
  },
  {
    label: 'American Alliance For Mergers and Acquisitions',
    value: 'join-paro-american-alliance-mergers-acquisitions',
  },
  {
    label: 'American Axle & Manufacturing',
    value: 'join-paro-american-axle-manufacturing',
  },
  {
    label: 'American Eagle Outfitters',
    value: 'join-paro-american-eagle-outfitters',
  },
  {
    label: 'American Electric Power',
    value: 'join-paro-american-electric-power',
  },
  { label: 'American Express', value: 'join-paro-american-express' },
  {
    label: 'American Family Insurance Group',
    value: 'join-paro-american-family-insurance-group',
  },
  {
    label: 'American Financial Group',
    value: 'join-paro-american-financial-group',
  },
  {
    label: 'American National Insurance',
    value: 'join-paro-american-national-insurance',
  },
  { label: 'American Tower', value: 'join-paro-american-tower' },
  { label: 'American Water Works', value: 'join-paro-american-water-works' },
  { label: 'Ameriprise Financial', value: 'join-paro-ameriprise-financial' },
  { label: 'AmerisourceBergen', value: 'join-paro-amerisourcebergen' },
  { label: 'Ametek', value: 'join-paro-ametek' },
  { label: 'Amgen', value: 'join-paro-amgen' },
  {
    label: 'Amica Mutual Insurance',
    value: 'join-paro-amica-mutual-insurance',
  },
  { label: 'Amkor Technology', value: 'join-paro-amkor-technology' },
  {
    label: 'AMN Healthcare Services',
    value: 'join-paro-amn-healthcare-services',
  },
  { label: 'Amphenol', value: 'join-paro-amphenol' },
  { label: 'Anadarko Petroleum', value: 'join-paro-anadarko-petroleum' },
  { label: 'Analog Devices', value: 'join-paro-analog-devices' },
  { label: 'Andersons', value: 'join-paro-andersons' },
  {
    label: 'Anixter International',
    value: 'join-paro-anixter-international',
  },
  {
    label: 'Annaly Capital Management',
    value: 'join-paro-annaly-capital-management',
  },
  { label: 'Antero Resources', value: 'join-paro-antero-resources' },
  { label: 'Anthem', value: 'join-paro-anthem' },
  { label: 'Apache', value: 'join-paro-apache' },
  { label: 'Apple', value: 'join-paro-apple' },
  {
    label: 'Applied Industrial Technologies',
    value: 'join-paro-applied-industrial-technologies',
  },
  { label: 'Applied Materials', value: 'join-paro-applied-materials' },
  { label: 'AptarGroup', value: 'join-paro-aptargroup' },
  { label: 'Aramark', value: 'join-paro-aramark' },
  { label: 'ArcBest', value: 'join-paro-arcbest' },
  { label: 'Arch Coal', value: 'join-paro-arch-coal' },
  {
    label: 'Archer Daniels Midland',
    value: 'join-paro-archer-daniels-midland',
  },
  { label: 'Arconic', value: 'join-paro-arconic' },
  { label: 'Arista Networks', value: 'join-paro-arista-networks' },
  { label: 'Arrow Electronics', value: 'join-paro-arrow-electronics' },
  { label: 'Arthur J. Gallagher', value: 'join-paro-arthur-j-gallagher' },
  {
    label: 'Asbury Automotive Group',
    value: 'join-paro-asbury-automotive-group',
  },
  { label: 'Ascena Retail Group', value: 'join-paro-ascena-retail-group' },
  { label: 'ASGN', value: 'join-paro-asgn' },
  {
    label: 'Ashland Global Holdings',
    value: 'join-paro-ashland-global-holdings',
  },
  { label: 'Assurant', value: 'join-paro-assurant' },
  { label: 'AT&T', value: 'join-paro-att' },
  {
    label: 'Atlas Air Worldwide Holdings',
    value: 'join-paro-atlas-air-worldwide-holdings',
  },
  { label: 'Atmos Energy', value: 'join-paro-atmos-energy' },
  {
    label: 'Auto-Owners Insurance',
    value: 'join-paro-auto-owners-insurance',
  },
  { label: 'Autodesk', value: 'join-paro-autodesk' },
  { label: 'Autoliv', value: 'join-paro-autoliv' },
  { label: 'AutoNation', value: 'join-paro-autonation' },
  { label: 'AutoZone', value: 'join-paro-autozone' },
  {
    label: 'AvalonBay Communities',
    value: 'join-paro-avalonbay-communities',
  },
  { label: 'Avaya Holdings', value: 'join-paro-avaya-holdings' },
  { label: 'Avery Dennison', value: 'join-paro-avery-dennison' },
  { label: 'Avis Budget Group', value: 'join-paro-avis-budget-group' },
  { label: 'Avnet', value: 'join-paro-avnet' },
  { label: 'Avon Products', value: 'join-paro-avon-products' },
  { label: 'Ball', value: 'join-paro-ball' },
  { label: 'Bank of America', value: 'join-paro-bank-of-america' },
  {
    label: 'Bank of New York Mellon',
    value: 'join-paro-bank-of-new-york-mellon',
  },
  { label: 'Barnes & Noble', value: 'join-paro-barnes-noble' },
  {
    label: 'Barnes & Noble Education',
    value: 'join-paro-barnes-noble-education',
  },
  { label: 'Baxter International', value: 'join-paro-baxter-international' },
  { label: 'BB&T Corp.', value: 'join-paro-bbt-corp-' },
  {
    label: 'Beacon Roofing Supply',
    value: 'join-paro-beacon-roofing-supply',
  },
  { label: 'Beazer Homes USA', value: 'join-paro-beazer-homes-usa' },
  { label: 'Becton Dickinson', value: 'join-paro-becton-dickinson' },
  { label: 'Bed Bath & Beyond', value: 'join-paro-bed-bath-beyond' },
  { label: 'Belden', value: 'join-paro-belden' },
  { label: 'Bemis', value: 'join-paro-bemis' },
  {
    label: 'Benchmark Electronics',
    value: 'join-paro-benchmark-electronics',
  },
  { label: 'Berkshire Hathaway', value: 'join-paro-berkshire-hathaway' },
  { label: 'Berry Global Group', value: 'join-paro-berry-global-group' },
  { label: 'Best Buy', value: 'join-paro-best-buy' },
  { label: 'Big Lots', value: 'join-paro-big-lots' },
  { label: 'Bio-Rad Laboratories', value: 'join-paro-bio-rad-laboratories' },
  { label: 'Biogen', value: 'join-paro-biogen' },
  { label: "BJ's Wholesale Club", value: 'join-paro-bjs-wholesale-club' },
  { label: 'BlackRock', value: 'join-paro-blackrock' },
  { label: 'Blackstone Group', value: 'join-paro-blackstone-group' },
  { label: "Bloomin' Brands", value: 'join-paro-bloomin-brands' },
  { label: 'BlueLinx Holdings', value: 'join-paro-bluelinx-holdings' },
  { label: 'BMC Stock Holdings', value: 'join-paro-bmc-stock-holdings' },
  { label: 'Boeing', value: 'join-paro-boeing' },
  { label: 'Boise Cascade', value: 'join-paro-boise-cascade' },
  { label: 'Booking Holdings', value: 'join-paro-booking-holdings' },
  { label: 'Booz Allen Hamilton', value: 'join-paro-booz-allen-hamilton' },
  { label: 'BorgWarner', value: 'join-paro-borgwarner' },
  { label: 'Boston Properties', value: 'join-paro-boston-properties' },
  { label: 'Boston Scientific', value: 'join-paro-boston-scientific' },
  { label: 'Boyd Gaming', value: 'join-paro-boyd-gaming' },
  {
    label: 'Brighthouse Financial',
    value: 'join-paro-brighthouse-financial',
  },
  { label: 'BrightView Holdings', value: 'join-paro-brightview-holdings' },
  { label: "Brink's", value: 'join-paro-brinks' },
  {
    label: 'Brinker International',
    value: 'join-paro-brinker-international',
  },
  { label: 'Bristol-Myers Squibb', value: 'join-paro-bristol-myers-squibb' },
  { label: 'Broadcom', value: 'join-paro-broadcom' },
  {
    label: 'Broadridge Financial Solutions',
    value: 'join-paro-broadridge-financial-solutions',
  },
  {
    label: 'Brookdale Senior Living',
    value: 'join-paro-brookdale-senior-living',
  },
  { label: 'Brown & Brown', value: 'join-paro-brown-brown' },
  { label: 'Brown-Forman', value: 'join-paro-brown-forman' },
  { label: 'Brunswick', value: 'join-paro-brunswick' },
  { label: 'Buckeye Partners', value: 'join-paro-buckeye-partners' },
  { label: 'Builders FirstSource', value: 'join-paro-builders-firstsource' },
  { label: 'Burlington Stores', value: 'join-paro-burlington-stores' },
  {
    label: 'C.H. Robinson Worldwide',
    value: 'join-paro-c-h-robinson-worldwide',
  },
  { label: 'C&J Energy Services', value: 'join-paro-cj-energy-services' },
  { label: 'CA', value: 'join-paro-ca' },
  { label: 'Cabot', value: 'join-paro-cabot' },
  { label: 'Cabot Oil & Gas', value: 'join-paro-cabot-oil-gas' },
  { label: 'CACI International', value: 'join-paro-caci-international' },
  {
    label: 'Cadence Design Systems',
    value: 'join-paro-cadence-design-systems',
  },
  {
    label: 'Caesars Entertainment',
    value: 'join-paro-caesars-entertainment',
  },
  { label: 'Caleres', value: 'join-paro-caleres' },
  { label: 'California Resources', value: 'join-paro-california-resources' },
  { label: 'Calpine', value: 'join-paro-calpine' },
  {
    label: 'Calumet Specialty Products',
    value: 'join-paro-calumet-specialty-products',
  },
  { label: 'Campbell Soup', value: 'join-paro-campbell-soup' },
  {
    label: 'Camping World Holdings',
    value: 'join-paro-camping-world-holdings',
  },
  {
    label: 'Capital One Financial',
    value: 'join-paro-capital-one-financial',
  },
  { label: 'Cardinal Health', value: 'join-paro-cardinal-health' },
  { label: 'Carlisle', value: 'join-paro-carlisle' },
  { label: 'Carlyle Group', value: 'join-paro-carlyle-group' },
  { label: 'CarMax', value: 'join-paro-carmax' },
  { label: 'Carpenter Technology', value: 'join-paro-carpenter-technology' },
  { label: "Carter's", value: 'join-paro-carters' },
  { label: 'Carvana', value: 'join-paro-carvana' },
  {
    label: "Casey's General Stores",
    value: 'join-paro-caseys-general-stores',
  },
  { label: 'Catalent', value: 'join-paro-catalent' },
  { label: 'Caterpillar', value: 'join-paro-caterpillar' },
  { label: 'Cboe Global Markets', value: 'join-paro-cboe-global-markets' },
  { label: 'CBRE Group', value: 'join-paro-cbre-group' },
  { label: 'CBS', value: 'join-paro-cbs' },
  { label: 'CDK Global', value: 'join-paro-cdk-global' },
  { label: 'CDW', value: 'join-paro-cdw' },
  { label: 'Celanese', value: 'join-paro-celanese' },
  { label: 'Celgene', value: 'join-paro-celgene' },
  { label: 'Centene', value: 'join-paro-centene' },
  { label: 'CenterPoint Energy', value: 'join-paro-centerpoint-energy' },
  { label: 'Central Garden & Pet', value: 'join-paro-central-garden-pet' },
  { label: 'Century Communities', value: 'join-paro-century-communities' },
  { label: 'CenturyLink', value: 'join-paro-centurylink' },
  { label: 'Cerner', value: 'join-paro-cerner' },
  {
    label: 'CF Industries Holdings',
    value: 'join-paro-cf-industries-holdings',
  },
  {
    label: 'Charles River Laboratories International',
    value: 'join-paro-charles-river-laboratories-international',
  },
  { label: 'Charles Schwab', value: 'join-paro-charles-schwab' },
  {
    label: 'Charter Communications',
    value: 'join-paro-charter-communications',
  },
  { label: 'Cheesecake Factory', value: 'join-paro-cheesecake-factory' },
  { label: 'Chemours', value: 'join-paro-chemours' },
  { label: 'Cheniere Energy', value: 'join-paro-cheniere-energy' },
  { label: 'Chesapeake Energy', value: 'join-paro-chesapeake-energy' },
  { label: 'Chevron', value: 'join-paro-chevron' },
  { label: "Chico's FAS", value: 'join-paro-chicos-fas' },
  {
    label: 'Chipotle Mexican Grill',
    value: 'join-paro-chipotle-mexican-grill',
  },
  { label: 'CHS', value: 'join-paro-chs' },
  { label: 'Church & Dwight', value: 'join-paro-church-dwight' },
  { label: 'Ciena', value: 'join-paro-ciena' },
  { label: 'Cigna', value: 'join-paro-cigna' },
  { label: 'Cimarex Energy', value: 'join-paro-cimarex-energy' },
  { label: 'Cincinnati Financial', value: 'join-paro-cincinnati-financial' },
  { label: 'Cinemark Holdings', value: 'join-paro-cinemark-holdings' },
  { label: 'Cintas', value: 'join-paro-cintas' },
  { label: 'Cisco Systems', value: 'join-paro-cisco-systems' },
  { label: 'CIT Group', value: 'join-paro-cit-group' },
  { label: 'Citigroup', value: 'join-paro-citigroup' },
  {
    label: 'Citizens Financial Group',
    value: 'join-paro-citizens-financial-group',
  },
  { label: 'Citrix Systems', value: 'join-paro-citrix-systems' },
  { label: 'Clean Harbors', value: 'join-paro-clean-harbors' },
  { label: 'Cleveland-Cliffs', value: 'join-paro-cleveland-cliffs' },
  { label: 'Clorox', value: 'join-paro-clorox' },
  { label: 'CME Group', value: 'join-paro-cme-group' },
  { label: 'CMS Energy', value: 'join-paro-cms-energy' },
  { label: 'CNO Financial Group', value: 'join-paro-cno-financial-group' },
  { label: 'Coca-Cola', value: 'join-paro-coca-cola' },
  {
    label: 'Coca-Cola Consolidated',
    value: 'join-paro-coca-cola-consolidated',
  },
  {
    label: 'Cognizant Technology Solutions',
    value: 'join-paro-cognizant-technology-solutions',
  },
  { label: 'Colfax', value: 'join-paro-colfax' },
  { label: 'Colgate-Palmolive', value: 'join-paro-colgate-palmolive' },
  { label: 'Colony Capital', value: 'join-paro-colony-capital' },
  { label: 'Columbia Sportswear', value: 'join-paro-columbia-sportswear' },
  { label: 'Comcast', value: 'join-paro-comcast' },
  { label: 'Comerica', value: 'join-paro-comerica' },
  { label: 'Comfort Systems USA', value: 'join-paro-comfort-systems-usa' },
  { label: 'Commercial Metals', value: 'join-paro-commercial-metals' },
  { label: 'CommScope Holding', value: 'join-paro-commscope-holding' },
  {
    label: 'Community Health Systems',
    value: 'join-paro-community-health-systems',
  },
  { label: 'Conagra Brands', value: 'join-paro-conagra-brands' },
  { label: 'Concho Resources', value: 'join-paro-concho-resources' },
  { label: 'Conduent', value: 'join-paro-conduent' },
  { label: 'ConocoPhillips', value: 'join-paro-conocophillips' },
  { label: 'Consolidated Edison', value: 'join-paro-consolidated-edison' },
  { label: 'Constellation Brands', value: 'join-paro-constellation-brands' },
  {
    label: 'Continental Resources',
    value: 'join-paro-continental-resources',
  },
  { label: 'Contura Energy', value: 'join-paro-contura-energy' },
  { label: 'Cooper Cos.', value: 'join-paro-cooper-cos-' },
  { label: 'Cooper Tire & Rubber', value: 'join-paro-cooper-tire-rubber' },
  {
    label: 'Cooper-Standard Holdings',
    value: 'join-paro-cooper-standard-holdings',
  },
  { label: 'Core-Mark Holding', value: 'join-paro-core-mark-holding' },
  { label: 'Corning', value: 'join-paro-corning' },
  { label: 'Costco Wholesale', value: 'join-paro-costco-wholesale' },
  { label: 'Coty', value: 'join-paro-coty' },
  { label: 'Country Financial', value: 'join-paro-country-financial' },
  {
    label: 'Cracker Barrel Old Country Store',
    value: 'join-paro-cracker-barrel-old-country-store',
  },
  { label: 'Crane', value: 'join-paro-crane' },
  {
    label: 'Crestwood Equity Partners',
    value: 'join-paro-crestwood-equity-partners',
  },
  {
    label: 'Crown Castle International',
    value: 'join-paro-crown-castle-international',
  },
  { label: 'Crown Holdings', value: 'join-paro-crown-holdings' },
  { label: 'CSX', value: 'join-paro-csx' },
  { label: 'Cummins', value: 'join-paro-cummins' },
  { label: 'CUNA Mutual Group', value: 'join-paro-cuna-mutual-group' },
  { label: 'Curtiss-Wright', value: 'join-paro-curtiss-wright' },
  { label: 'CVS Health', value: 'join-paro-cvs-health' },
  {
    label: 'Cypress Semiconductor',
    value: 'join-paro-cypress-semiconductor',
  },
  { label: 'D.R. Horton', value: 'join-paro-d-r-horton' },
  { label: 'Dana', value: 'join-paro-dana' },
  { label: 'Danaher', value: 'join-paro-danaher' },
  { label: 'Darden Restaurants', value: 'join-paro-darden-restaurants' },
  { label: 'Darling Ingredients', value: 'join-paro-darling-ingredients' },
  { label: 'DaVita', value: 'join-paro-davita' },
  { label: 'DCP Midstream', value: 'join-paro-dcp-midstream' },
  { label: 'Dean Foods', value: 'join-paro-dean-foods' },
  { label: 'Deere', value: 'join-paro-deere' },
  { label: 'Delek US Holdings', value: 'join-paro-delek-us-holdings' },
  { label: 'Dell Technologies', value: 'join-paro-dell-technologies' },
  { label: 'Delta Air Lines', value: 'join-paro-delta-air-lines' },
  {
    label: 'Delta Tucker Holdings',
    value: 'join-paro-delta-tucker-holdings',
  },
  { label: 'Deluxe', value: 'join-paro-deluxe' },
  { label: 'Dentsply Sirona', value: 'join-paro-dentsply-sirona' },
  { label: 'Designer Brands', value: 'join-paro-designer-brands' },
  { label: 'Devon Energy', value: 'join-paro-devon-energy' },
  { label: 'Diamondback Energy', value: 'join-paro-diamondback-energy' },
  {
    label: "Dick's Sporting Goods",
    value: 'join-paro-dicks-sporting-goods',
  },
  { label: 'Diebold Nixdorf', value: 'join-paro-diebold-nixdorf' },
  { label: 'Digital Realty Trust', value: 'join-paro-digital-realty-trust' },
  { label: "Dillard's", value: 'join-paro-dillards' },
  { label: 'Diplomat Pharmacy', value: 'join-paro-diplomat-pharmacy' },
  {
    label: 'Discover Financial Services',
    value: 'join-paro-discover-financial-services',
  },
  { label: 'Discovery', value: 'join-paro-discovery' },
  { label: 'DISH Network', value: 'join-paro-dish-network' },
  { label: 'Dollar General', value: 'join-paro-dollar-general' },
  { label: 'Dollar Tree', value: 'join-paro-dollar-tree' },
  { label: 'Dominion Energy', value: 'join-paro-dominion-energy' },
  { label: "Domino's Pizza", value: 'join-paro-dominos-pizza' },
  { label: 'Domtar', value: 'join-paro-domtar' },
  { label: 'Donaldson', value: 'join-paro-donaldson' },
  { label: 'Dover', value: 'join-paro-dover' },
  { label: 'DTE Energy', value: 'join-paro-dte-energy' },
  { label: 'Duke Energy', value: 'join-paro-duke-energy' },
  { label: 'DuPont de Nemours', value: 'join-paro-dupont-de-nemours' },
  { label: 'DXC Technology', value: 'join-paro-dxc-technology' },
  { label: 'Dycom Industries', value: 'join-paro-dycom-industries' },
  { label: 'E*Trade Financial', value: 'join-paro-e-trade-financial' },
  { label: 'Eastman Chemical', value: 'join-paro-eastman-chemical' },
  { label: 'eBay', value: 'join-paro-ebay' },
  {
    label: 'Echo Global Logistics',
    value: 'join-paro-echo-global-logistics',
  },
  { label: 'EchoStar', value: 'join-paro-echostar' },
  { label: 'Ecolab', value: 'join-paro-ecolab' },
  {
    label: 'Edgewell Personal Care',
    value: 'join-paro-edgewell-personal-care',
  },
  { label: 'Edison International', value: 'join-paro-edison-international' },
  { label: 'Edwards Lifesciences', value: 'join-paro-edwards-lifesciences' },
  { label: 'Eldorado Resorts', value: 'join-paro-eldorado-resorts' },
  { label: 'Electronic Arts', value: 'join-paro-electronic-arts' },
  { label: 'Element Solutions', value: 'join-paro-element-solutions' },
  { label: 'Eli Lilly', value: 'join-paro-eli-lilly' },
  { label: 'EMCOR Group', value: 'join-paro-emcor-group' },
  { label: 'Emerson Electric', value: 'join-paro-emerson-electric' },
  {
    label: 'Enable Midstream Partners',
    value: 'join-paro-enable-midstream-partners',
  },
  { label: 'Encompass Health', value: 'join-paro-encompass-health' },
  { label: 'Energy Transfer', value: 'join-paro-energy-transfer' },
  { label: 'EnerSys', value: 'join-paro-enersys' },
  { label: 'EnLink Midstream', value: 'join-paro-enlink-midstream' },
  { label: 'Ensign Group', value: 'join-paro-ensign-group' },
  { label: 'Entergy', value: 'join-paro-entergy' },
  {
    label: 'Enterprise Products Partners',
    value: 'join-paro-enterprise-products-partners',
  },
  { label: 'EOG Resources', value: 'join-paro-eog-resources' },
  { label: 'EQT', value: 'join-paro-eqt' },
  { label: 'Equifax', value: 'join-paro-equifax' },
  { label: 'Equinix', value: 'join-paro-equinix' },
  { label: 'Equity Residential', value: 'join-paro-equity-residential' },
  { label: 'Erie Insurance Group', value: 'join-paro-erie-insurance-group' },
  { label: 'Estee Lauder', value: 'join-paro-estee-lauder' },
  {
    label: 'Esterline Technologies',
    value: 'join-paro-esterline-technologies',
  },
  { label: 'Euronet Worldwide', value: 'join-paro-euronet-worldwide' },
  { label: 'Evercore', value: 'join-paro-evercore' },
  { label: 'Evergy', value: 'join-paro-evergy' },
  { label: 'Eversource Energy', value: 'join-paro-eversource-energy' },
  { label: 'Exelon', value: 'join-paro-exelon' },
  { label: 'Expedia Group', value: 'join-paro-expedia-group' },
  {
    label: 'Expeditors Intl. of Washington',
    value: 'join-paro-expeditors-intl-of-washington',
  },
  { label: 'Express', value: 'join-paro-express' },
  { label: 'Exxon Mobil', value: 'join-paro-exxon-mobil' },
  { label: 'F5 Networks', value: 'join-paro-f5-networks' },
  { label: 'Facebook', value: 'join-paro-facebook' },
  { label: 'Fannie Mae', value: 'join-paro-fannie-mae' },
  {
    label: 'Farmers Insurance Exchange',
    value: 'join-paro-farmers-insurance-exchange',
  },
  { label: 'Fastenal', value: 'join-paro-fastenal' },
  { label: 'FedEx', value: 'join-paro-fedex' },
  { label: 'Ferrellgas Partners', value: 'join-paro-ferrellgas-partners' },
  {
    label: 'Fidelity National Financial',
    value: 'join-paro-fidelity-national-financial',
  },
  {
    label: 'Fidelity National Information Services',
    value: 'join-paro-fidelity-national-information-services',
  },
  { label: 'Fifth Third Bancorp', value: 'join-paro-fifth-third-bancorp' },
  {
    label: 'First American Financial',
    value: 'join-paro-first-american-financial',
  },
  { label: 'First Data', value: 'join-paro-first-data' },
  {
    label: 'First Horizon National Corp.',
    value: 'join-paro-first-horizon-national-corp-',
  },
  { label: 'First Republic Bank', value: 'join-paro-first-republic-bank' },
  { label: 'First Solar', value: 'join-paro-first-solar' },
  { label: 'FirstEnergy', value: 'join-paro-firstenergy' },
  { label: 'Fiserv', value: 'join-paro-fiserv' },
  {
    label: 'FleetCor Technologies',
    value: 'join-paro-fleetcor-technologies',
  },
  { label: 'Flowers Foods', value: 'join-paro-flowers-foods' },
  { label: 'Flowserve', value: 'join-paro-flowserve' },
  { label: 'Fluor', value: 'join-paro-fluor' },
  { label: 'FM Global', value: 'join-paro-fm-global' },
  { label: 'FMC', value: 'join-paro-fmc' },
  { label: 'Foot Locker', value: 'join-paro-foot-locker' },
  { label: 'Ford Motor', value: 'join-paro-ford-motor' },
  { label: 'Fortive', value: 'join-paro-fortive' },
  {
    label: 'Fortune Brands Home & Security',
    value: 'join-paro-fortune-brands-home-security',
  },
  { label: 'Fossil Group', value: 'join-paro-fossil-group' },
  {
    label: 'Foundation Building Materials',
    value: 'join-paro-foundation-building-materials',
  },
  { label: 'Franklin Resources', value: 'join-paro-franklin-resources' },
  { label: 'Freddie Mac', value: 'join-paro-freddie-mac' },
  { label: 'Freeport-McMoRan', value: 'join-paro-freeport-mcmoran' },
  {
    label: 'Frontier Communications',
    value: 'join-paro-frontier-communications',
  },
  { label: 'FTI Consulting', value: 'join-paro-fti-consulting' },
  { label: 'G-III Apparel Group', value: 'join-paro-g-iii-apparel-group' },
  { label: 'GameStop', value: 'join-paro-gamestop' },
  { label: 'Gannett', value: 'join-paro-gannett' },
  { label: 'Gap', value: 'join-paro-gap' },
  { label: 'Gardner Denver', value: 'join-paro-gardner-denver' },
  { label: 'Gartner', value: 'join-paro-gartner' },
  { label: 'Generac Holdings', value: 'join-paro-generac-holdings' },
  { label: 'General Dynamics', value: 'join-paro-general-dynamics' },
  { label: 'General Electric', value: 'join-paro-general-electric' },
  { label: 'General Mills', value: 'join-paro-general-mills' },
  { label: 'General Motors', value: 'join-paro-general-motors' },
  { label: 'Genesco', value: 'join-paro-genesco' },
  { label: 'Genesee & Wyoming', value: 'join-paro-genesee-wyoming' },
  { label: 'Genesis Energy', value: 'join-paro-genesis-energy' },
  { label: 'Genesis Healthcare', value: 'join-paro-genesis-healthcare' },
  { label: 'Genuine Parts', value: 'join-paro-genuine-parts' },
  { label: 'Genworth Financial', value: 'join-paro-genworth-financial' },
  { label: 'GEO Group', value: 'join-paro-geo-group' },
  { label: 'Gilead Sciences', value: 'join-paro-gilead-sciences' },
  { label: 'Global Partners', value: 'join-paro-global-partners' },
  { label: 'Global Payments', value: 'join-paro-global-payments' },
  { label: 'GMS', value: 'join-paro-gms' },
  { label: 'GNC Holdings', value: 'join-paro-gnc-holdings' },
  { label: 'GoDaddy', value: 'join-paro-godaddy' },
  { label: 'Goldman Sachs Group', value: 'join-paro-goldman-sachs-group' },
  {
    label: 'Goodyear Tire & Rubber',
    value: 'join-paro-goodyear-tire-rubber',
  },
  { label: 'Graham Holdings', value: 'join-paro-graham-holdings' },
  { label: 'Granite Construction', value: 'join-paro-granite-construction' },
  {
    label: 'Graphic Packaging Holding',
    value: 'join-paro-graphic-packaging-holding',
  },
  { label: 'Graybar Electric', value: 'join-paro-graybar-electric' },
  { label: 'Green Plains', value: 'join-paro-green-plains' },
  { label: 'Greenbrier Cos.', value: 'join-paro-greenbrier-cos-' },
  { label: 'Greif', value: 'join-paro-greif' },
  { label: 'Griffon', value: 'join-paro-griffon' },
  { label: 'Group 1 Automotive', value: 'join-paro-group-1-automotive' },
  { label: 'Groupon', value: 'join-paro-groupon' },
  {
    label: 'Guardian Life Ins. Co. of America',
    value: 'join-paro-guardian-life-ins-co-of-america',
  },
  { label: 'Guess', value: 'join-paro-guess' },
  { label: 'H.B. Fuller', value: 'join-paro-h-b-fuller' },
  { label: 'H&R Block', value: 'join-paro-hr-block' },
  { label: 'Hain Celestial Group', value: 'join-paro-hain-celestial-group' },
  { label: 'Halliburton', value: 'join-paro-halliburton' },
  { label: 'Hanesbrands', value: 'join-paro-hanesbrands' },
  {
    label: 'Hanover Insurance Group',
    value: 'join-paro-hanover-insurance-group',
  },
  { label: 'Harley-Davidson', value: 'join-paro-harley-davidson' },
  { label: 'Harris', value: 'join-paro-harris' },
  {
    label: 'Hartford Financial Services',
    value: 'join-paro-hartford-financial-services',
  },
  { label: 'Hasbro', value: 'join-paro-hasbro' },
  {
    label: 'Hawaiian Electric Industries',
    value: 'join-paro-hawaiian-electric-industries',
  },
  { label: 'Hawaiian Holdings', value: 'join-paro-hawaiian-holdings' },
  { label: 'HC2 Holdings', value: 'join-paro-hc2-holdings' },
  { label: 'HCA Healthcare', value: 'join-paro-hca-healthcare' },
  { label: 'HD Supply Holdings', value: 'join-paro-hd-supply-holdings' },
  {
    label: 'Healthcare Services Group',
    value: 'join-paro-healthcare-services-group',
  },
  { label: 'Helmerich & Payne', value: 'join-paro-helmerich-payne' },
  { label: 'Henry Schein', value: 'join-paro-henry-schein' },
  { label: 'Herc Holdings', value: 'join-paro-herc-holdings' },
  { label: 'Herman Miller', value: 'join-paro-herman-miller' },
  { label: 'Hershey', value: 'join-paro-hershey' },
  {
    label: 'Hertz Global Holdings',
    value: 'join-paro-hertz-global-holdings',
  },
  { label: 'Hess', value: 'join-paro-hess' },
  {
    label: 'Hewlett Packard Enterprise',
    value: 'join-paro-hewlett-packard-enterprise',
  },
  { label: 'Hexcel', value: 'join-paro-hexcel' },
  { label: 'Hexion', value: 'join-paro-hexion' },
  { label: 'Hill-Rom Holdings', value: 'join-paro-hill-rom-holdings' },
  {
    label: 'Hilton Grand Vacations',
    value: 'join-paro-hilton-grand-vacations',
  },
  {
    label: 'Hilton Worldwide Holdings',
    value: 'join-paro-hilton',
  },
  { label: 'HNI', value: 'join-paro-hni' },
  { label: 'HollyFrontier', value: 'join-paro-hollyfrontier' },
  { label: 'Hologic', value: 'join-paro-hologic' },
  { label: 'Home Depot', value: 'join-paro-home-depot' },
  {
    label: 'Honeywell International',
    value: 'join-paro-honeywell-international',
  },
  { label: 'Hormel Foods', value: 'join-paro-hormel-foods' },
  {
    label: 'Hospitality Properties Trust',
    value: 'join-paro-hospitality-properties-trust',
  },
  { label: 'Host Hotels & Resorts', value: 'join-paro-host-hotels-resorts' },
  {
    label: 'Hovnanian Enterprises',
    value: 'join-paro-hovnanian-enterprises',
  },
  { label: 'HP', value: 'join-paro-hp' },
  { label: 'Hub Group', value: 'join-paro-hub-group' },
  { label: 'Hubbell', value: 'join-paro-hubbell' },
  { label: 'Humana', value: 'join-paro-humana' },
  {
    label: 'Huntington Bancshares',
    value: 'join-paro-huntington-bancshares',
  },
  {
    label: 'Huntington Ingalls Industries',
    value: 'join-paro-huntington-ingalls-industries',
  },
  { label: 'Huntsman', value: 'join-paro-huntsman' },
  { label: 'Hyatt Hotels', value: 'join-paro-hyatt-hotels' },
  {
    label: 'Hyster-Yale Materials Handling',
    value: 'join-paro-hyster-yale-materials-handling',
  },
  { label: 'IAC/InterActiveCorp', value: 'join-paro-iac/interactivecorp' },
  { label: 'IBM', value: 'join-paro-ibm' },
  { label: 'Icahn Enterprises', value: 'join-paro-icahn-enterprises' },
  { label: 'IDEX', value: 'join-paro-idex' },
  { label: 'IDEXX Laboratories', value: 'join-paro-idexx-laboratories' },
  { label: 'iHeartMedia', value: 'join-paro-iheartmedia' },
  { label: 'Illinois Tool Works', value: 'join-paro-illinois-tool-works' },
  { label: 'Illumina', value: 'join-paro-illumina' },
  { label: 'Infor', value: 'join-paro-infor' },
  { label: 'Ingles Markets', value: 'join-paro-ingles-markets' },
  { label: 'Ingredion', value: 'join-paro-ingredion' },
  { label: 'Insight Enterprises', value: 'join-paro-insight-enterprises' },
  { label: 'Insperity', value: 'join-paro-insperity' },
  { label: 'Intel', value: 'join-paro-intel' },
  {
    label: 'Interactive Brokers Group',
    value: 'join-paro-interactive-brokers-group',
  },
  {
    label: 'Intercontinental Exchange',
    value: 'join-paro-intercontinental-exchange',
  },
  {
    label: 'International Flavors & Fragrances',
    value: 'join-paro-international-flavors-fragrances',
  },
  { label: 'International Paper', value: 'join-paro-international-paper' },
  { label: 'Interpublic Group', value: 'join-paro-interpublic-group' },
  { label: 'INTL FCStone', value: 'join-paro-intl-fcstone' },
  { label: 'Intuit', value: 'join-paro-intuit' },
  { label: 'Intuitive Surgical', value: 'join-paro-intuitive-surgical' },
  { label: 'IQVIA Holdings', value: 'join-paro-iqvia-holdings' },
  { label: 'Iron Mountain', value: 'join-paro-iron-mountain' },
  { label: 'Itron', value: 'join-paro-itron' },
  { label: 'ITT', value: 'join-paro-itt' },
  {
    label: 'J.B. Hunt Transport Services',
    value: 'join-paro-j-b-hunt-transport-services',
  },
  { label: 'J.C. Penney', value: 'join-paro-j-c-penney' },
  { label: 'J.Crew Group', value: 'join-paro-j-crew-group' },
  { label: 'J.M. Smucker', value: 'join-paro-j-m-smucker' },
  { label: 'Jabil', value: 'join-paro-jabil' },
  {
    label: 'Jacobs Engineering Group',
    value: 'join-paro-jacobs-engineering-group',
  },
  {
    label: 'Jefferies Financial Group',
    value: 'join-paro-jefferies-financial-group',
  },
  { label: 'JELD-WEN Holding', value: 'join-paro-jeld-wen-holding' },
  { label: 'JetBlue Airways', value: 'join-paro-jetblue-airways' },
  { label: 'Johnson & Johnson', value: 'join-paro-johnson-johnson' },
  {
    label: 'Jones Financial (Edward Jones)',
    value: 'join-paro-jones-financial-(edward-jones)',
  },
  { label: 'Jones Lang LaSalle', value: 'join-paro-jones-lang-lasalle' },
  { label: 'JPMorgan Chase', value: 'join-paro-jpmorgan-chase' },
  { label: 'Juniper Networks', value: 'join-paro-juniper-networks' },
  { label: 'Kansas City Southern', value: 'join-paro-kansas-city-southern' },
  { label: 'Kar Auction Services', value: 'join-paro-kar-auction-services' },
  { label: 'KB Home', value: 'join-paro-kb-home' },
  { label: 'KBR', value: 'join-paro-kbr' },
  { label: 'Keane Group', value: 'join-paro-keane-group' },
  { label: 'Kellogg', value: 'join-paro-kellogg' },
  { label: 'Kelly Services', value: 'join-paro-kelly-services' },
  { label: 'Kemper', value: 'join-paro-kemper' },
  { label: 'Kennametal', value: 'join-paro-kennametal' },
  { label: 'Keurig Dr Pepper', value: 'join-paro-keurig-dr-pepper' },
  { label: 'KeyCorp', value: 'join-paro-keycorp' },
  {
    label: 'Keysight Technologies',
    value: 'join-paro-keysight-technologies',
  },
  { label: 'Kimberly-Clark', value: 'join-paro-kimberly-clark' },
  { label: 'Kinder Morgan', value: 'join-paro-kinder-morgan' },
  { label: 'Kirby', value: 'join-paro-kirby' },
  { label: 'KKR', value: 'join-paro-kkr' },
  { label: 'KLA-Tencor', value: 'join-paro-kla-tencor' },
  {
    label: 'Knight-Swift Transportation Holdings',
    value: 'join-paro-knight-swift-transportation-holdings',
  },
  { label: 'Knights of Columbus', value: 'join-paro-knights-of-columbus' },
  { label: "Kohl's", value: 'join-paro-kohls' },
  { label: 'Kraft Heinz', value: 'join-paro-kraft-heinz' },
  { label: 'Kraton', value: 'join-paro-kraton' },
  { label: 'Kroger', value: 'join-paro-kroger' },
  { label: 'L Brands', value: 'join-paro-l-brands' },
  { label: 'L3 Technologies', value: 'join-paro-l3-technologies' },
  {
    label: 'Laboratory Corp. of America',
    value: 'join-paro-laboratory-corp-of-america',
  },
  { label: 'Lam Research', value: 'join-paro-lam-research' },
  { label: 'Lamb Weston Holdings', value: 'join-paro-lamb-weston-holdings' },
  { label: "Land O'Lakes", value: 'join-paro-land-olakes' },
  { label: 'Landstar System', value: 'join-paro-landstar-system' },
  { label: 'Las Vegas Sands', value: 'join-paro-las-vegas-sands' },
  { label: 'Laureate Education', value: 'join-paro-laureate-education' },
  { label: 'LCI Industries', value: 'join-paro-lci-industries' },
  { label: 'Lear', value: 'join-paro-lear' },
  { label: 'Legg Mason', value: 'join-paro-legg-mason' },
  { label: 'Leggett & Platt', value: 'join-paro-leggett-platt' },
  { label: 'Leidos Holdings', value: 'join-paro-leidos-holdings' },
  { label: 'Lennar', value: 'join-paro-lennar' },
  { label: 'Lennox International', value: 'join-paro-lennox-international' },
  { label: 'Levi Strauss', value: 'join-paro-levi-strauss' },
  { label: 'Liberty Media', value: 'join-paro-liberty-media' },
  {
    label: 'Liberty Mutual Insurance Group',
    value: 'join-paro-liberty-mutual-insurance-group',
  },
  {
    label: 'Liberty Oilfield Services',
    value: 'join-paro-liberty-oilfield-services',
  },
  {
    label: 'Lincoln Electric Holdings',
    value: 'join-paro-lincoln-electric-holdings',
  },
  { label: 'Lincoln National', value: 'join-paro-lincoln-national' },
  { label: 'Lithia Motors', value: 'join-paro-lithia-motors' },
  {
    label: 'Live Nation Entertainment',
    value: 'join-paro-live-nation-entertainment',
  },
  { label: 'LKQ', value: 'join-paro-lkq' },
  { label: 'Lockheed Martin', value: 'join-paro-lockheed-martin' },
  { label: 'Loews', value: 'join-paro-loews' },
  { label: 'Louisiana-Pacific', value: 'join-paro-louisiana-pacific' },
  { label: "Lowe's", value: 'join-paro-lowes' },
  {
    label: 'LPL Financial Holdings',
    value: 'join-paro-lpl-financial-holdings',
  },
  { label: 'LSC Communications', value: 'join-paro-lsc-communications' },
  { label: 'Lyft', value: 'join-paro-lyft' },
  { label: 'M/I Homes', value: 'join-paro-m/i-homes' },
  { label: 'M&T Bank Corp.', value: 'join-paro-mt-bank-corp-' },
  { label: "Macy's", value: 'join-paro-macys' },
  { label: 'Magellan Health', value: 'join-paro-magellan-health' },
  {
    label: 'Magellan Midstream Partners',
    value: 'join-paro-magellan-midstream-partners',
  },
  { label: 'ManpowerGroup', value: 'join-paro-manpowergroup' },
  {
    label: 'ManTech International',
    value: 'join-paro-mantech-international',
  },
  { label: 'Marathon Oil', value: 'join-paro-marathon-oil' },
  { label: 'Marathon Petroleum', value: 'join-paro-marathon-petroleum' },
  { label: 'Markel', value: 'join-paro-markel' },
  {
    label: 'Marriott International',
    value: 'join-paro-marriott',
  },
  {
    label: 'Marriott Vacations Worldwide',
    value: 'join-paro-marriott-vacations-worldwide',
  },
  { label: 'Marsh & McLennan', value: 'join-paro-marsh-mclennan' },
  {
    label: 'Martin Marietta Materials',
    value: 'join-paro-martin-marietta-materials',
  },
  { label: 'Masco', value: 'join-paro-masco' },
  {
    label: 'Massachusetts Mutual Life Insurance',
    value: 'join-paro-massachusetts-mutual-life-insurance',
  },
  { label: 'MasTec', value: 'join-paro-mastec' },
  { label: 'Mastercard', value: 'join-paro-mastercard' },
  { label: 'Matson', value: 'join-paro-matson' },
  { label: 'Mattel', value: 'join-paro-mattel' },
  { label: 'Maxar Technologies', value: 'join-paro-maxar-technologies' },
  {
    label: 'Maxim Integrated Products',
    value: 'join-paro-maxim-integrated-products',
  },
  { label: 'Maximus', value: 'join-paro-maximus' },
  { label: 'McCormick', value: 'join-paro-mccormick' },
  { label: "McDonald's", value: 'join-paro-mcdonalds' },
  { label: 'McKesson', value: 'join-paro-mckesson' },
  { label: 'MDC Holdings', value: 'join-paro-mdc-holdings' },
  { label: 'MDU Resources Group', value: 'join-paro-mdu-resources-group' },
  {
    label: 'Medical Mutual of Ohio',
    value: 'join-paro-medical-mutual-of-ohio',
  },
  { label: 'Mednax', value: 'join-paro-mednax' },
  { label: 'Merck', value: 'join-paro-merck' },
  { label: 'Mercury General', value: 'join-paro-mercury-general' },
  { label: 'Meredith', value: 'join-paro-meredith' },
  { label: 'Meritage Homes', value: 'join-paro-meritage-homes' },
  { label: 'Meritor', value: 'join-paro-meritor' },
  { label: 'MetLife', value: 'join-paro-metlife' },
  {
    label: 'Mettler-Toledo International',
    value: 'join-paro-mettler-toledo-international',
  },
  {
    label: 'MGM Resorts International',
    value: 'join-paro-mgm-resorts-international',
  },
  { label: 'Michaels Cos.', value: 'join-paro-michaels-cos-' },
  { label: 'Microchip Technology', value: 'join-paro-microchip-technology' },
  { label: 'Micron Technology', value: 'join-paro-micron-technology' },
  { label: 'Microsoft', value: 'join-paro-microsoft' },
  { label: 'Middleby', value: 'join-paro-middleby' },
  { label: 'MKS Instruments', value: 'join-paro-mks-instruments' },
  { label: 'Modine Manufacturing', value: 'join-paro-modine-manufacturing' },
  { label: 'Mohawk Industries', value: 'join-paro-mohawk-industries' },
  { label: 'Molina Healthcare', value: 'join-paro-molina-healthcare' },
  { label: 'Molson Coors Brewing', value: 'join-paro-molson-coors-brewing' },
  {
    label: 'Mondelez International',
    value: 'join-paro-mondelez-international',
  },
  { label: 'Monster Beverage', value: 'join-paro-monster-beverage' },
  { label: "Moody's", value: 'join-paro-moodys' },
  { label: 'Moog', value: 'join-paro-moog' },
  { label: 'Morgan Stanley', value: 'join-paro-morgan-stanley' },
  { label: 'Mosaic', value: 'join-paro-mosaic' },
  { label: 'Motorola Solutions', value: 'join-paro-motorola-solutions' },
  { label: 'MPM Holdings', value: 'join-paro-mpm-holdings' },
  { label: 'MRC Global', value: 'join-paro-mrc-global' },
  {
    label: 'MSC Industrial Direct',
    value: 'join-paro-msc-industrial-direct',
  },
  { label: 'Mueller Industries', value: 'join-paro-mueller-industries' },
  { label: 'Murphy Oil', value: 'join-paro-murphy-oil' },
  { label: 'Murphy USA', value: 'join-paro-murphy-usa' },
  {
    label: 'Mutual of America Life Insurance',
    value: 'join-paro-mutual-of-america-life-insurance',
  },
  {
    label: 'Mutual of Omaha Insurance',
    value: 'join-paro-mutual-of-omaha-insurance',
  },
  { label: 'Nasdaq', value: 'join-paro-nasdaq' },
  {
    label: 'National General Holdings',
    value: 'join-paro-national-general-holdings',
  },
  {
    label: 'National Oilwell Varco',
    value: 'join-paro-national-oilwell-varco',
  },
  { label: 'Nationwide', value: 'join-paro-nationwide' },
  { label: 'Navient', value: 'join-paro-navient' },
  {
    label: 'Navistar International',
    value: 'join-paro-navistar-international',
  },
  { label: 'NCI Building Systems', value: 'join-paro-nci-building-systems' },
  { label: 'NCR', value: 'join-paro-ncr' },
  { label: 'Neiman Marcus Group', value: 'join-paro-neiman-marcus-group' },
  { label: 'NetApp', value: 'join-paro-netapp' },
  { label: 'Netflix', value: 'join-paro-netflix' },
  { label: 'New Jersey Resources', value: 'join-paro-new-jersey-resources' },
  {
    label: 'New Residential Investment',
    value: 'join-paro-new-residential-investment',
  },
  {
    label: 'New York Life Insurance',
    value: 'join-paro-new-york-life-insurance',
  },
  { label: 'Newell Brands', value: 'join-paro-newell-brands' },
  { label: 'Newfield Exploration', value: 'join-paro-newfield-exploration' },
  { label: 'Newmark Group', value: 'join-paro-newmark-group' },
  { label: 'NewMarket', value: 'join-paro-newmarket' },
  { label: 'Newmont Goldcorp', value: 'join-paro-newmont-goldcorp' },
  { label: 'News Corp.', value: 'join-paro-news-corp-' },
  { label: 'Nexeo Solutions', value: 'join-paro-nexeo-solutions' },
  { label: 'Nexstar Media Group', value: 'join-paro-nexstar-media-group' },
  { label: 'NextEra Energy', value: 'join-paro-nextera-energy' },
  { label: 'NGL Energy Partners', value: 'join-paro-ngl-energy-partners' },
  { label: 'Nike', value: 'join-paro-nike' },
  { label: 'NiSource', value: 'join-paro-nisource' },
  { label: 'Noble Energy', value: 'join-paro-noble-energy' },
  { label: 'Nordson', value: 'join-paro-nordson' },
  { label: 'Nordstrom', value: 'join-paro-nordstrom' },
  { label: 'Norfolk Southern', value: 'join-paro-norfolk-southern' },
  { label: 'Northern Trust', value: 'join-paro-northern-trust' },
  { label: 'Northrop Grumman', value: 'join-paro-northrop-grumman' },
  { label: 'Northwestern Mutual', value: 'join-paro-northwestern-mutual' },
  { label: 'NOW', value: 'join-paro-now' },
  { label: 'NRG Energy', value: 'join-paro-nrg-energy' },
  { label: 'Nu Skin Enterprises', value: 'join-paro-nu-skin-enterprises' },
  {
    label: 'Nuance Communications',
    value: 'join-paro-nuance-communications',
  },
  { label: 'Nucor', value: 'join-paro-nucor' },
  { label: 'NuStar Energy', value: 'join-paro-nustar-energy' },
  { label: 'Nvidia', value: 'join-paro-nvidia' },
  { label: 'NVR', value: 'join-paro-nvr' },
  { label: "O'Reilly Automotive", value: 'join-paro-oreilly-automotive' },
  { label: 'Oasis Petroleum', value: 'join-paro-oasis-petroleum' },
  { label: 'Occidental Petroleum', value: 'join-paro-occidental-petroleum' },
  { label: 'Office Depot', value: 'join-paro-office-depot' },
  { label: 'OGE Energy', value: 'join-paro-oge-energy' },
  { label: 'Ohio National Mutual', value: 'join-paro-ohio-national-mutual' },
  {
    label: 'Old Dominion Freight Line',
    value: 'join-paro-old-dominion-freight-line',
  },
  {
    label: 'Old Republic International',
    value: 'join-paro-old-republic-international',
  },
  { label: 'Olin', value: 'join-paro-olin' },
  { label: 'Omnicom Group', value: 'join-paro-omnicom-group' },
  { label: 'ON Semiconductor', value: 'join-paro-on-semiconductor' },
  { label: 'OneMain Holdings', value: 'join-paro-onemain-holdings' },
  { label: 'Oneok', value: 'join-paro-oneok' },
  { label: 'Oracle', value: 'join-paro-oracle' },
  { label: 'Oshkosh', value: 'join-paro-oshkosh' },
  { label: 'Owens & Minor', value: 'join-paro-owens-minor' },
  { label: 'Owens Corning', value: 'join-paro-owens-corning' },
  { label: 'Owens-Illinois', value: 'join-paro-owens-illinois' },
  { label: 'Paccar', value: 'join-paro-paccar' },
  { label: 'Pacific Life', value: 'join-paro-pacific-life' },
  {
    label: 'Packaging Corp. of America',
    value: 'join-paro-packaging-corp-of-america',
  },
  { label: 'Palo Alto Networks', value: 'join-paro-palo-alto-networks' },
  { label: 'Par Pacific Holdings', value: 'join-paro-par-pacific-holdings' },
  { label: 'Park Hotels & Resorts', value: 'join-paro-park-hotels-resorts' },
  { label: 'Parker-Hannifin', value: 'join-paro-parker-hannifin' },
  { label: 'Party City Holdco', value: 'join-paro-party-city-holdco' },
  { label: 'Patrick Industries', value: 'join-paro-patrick-industries' },
  { label: 'Patterson', value: 'join-paro-patterson' },
  { label: 'Patterson-UTI Energy', value: 'join-paro-patterson-uti-energy' },
  { label: 'Paychex', value: 'join-paro-paychex' },
  { label: 'PayPal Holdings', value: 'join-paro-paypal-holdings' },
  { label: 'PBF Energy', value: 'join-paro-pbf-energy' },
  { label: 'PC Connection', value: 'join-paro-pc-connection' },
  { label: 'PCM', value: 'join-paro-pcm' },
  { label: 'Peabody Energy', value: 'join-paro-peabody-energy' },
  {
    label: 'Penn Mutual Life Insurance',
    value: 'join-paro-penn-mutual-life-insurance',
  },
  { label: 'Penn National Gaming', value: 'join-paro-penn-national-gaming' },
  {
    label: 'Penske Automotive Group',
    value: 'join-paro-penske-automotive-group',
  },
  { label: 'PepsiCo', value: 'join-paro-pepsico' },
  {
    label: 'Performance Food Group',
    value: 'join-paro-performance-food-group',
  },
  { label: 'PerkinElmer', value: 'join-paro-perkinelmer' },
  { label: "Peter Kiewit Sons'", value: 'join-paro-peter-kiewit-sons' },
  { label: 'Pfizer', value: 'join-paro-pfizer' },
  { label: 'PG&E', value: 'join-paro-pge' },
  {
    label: 'Philip Morris International',
    value: 'join-paro-philip-morris-international',
  },
  { label: 'Phillips 66', value: 'join-paro-phillips-66' },
  {
    label: 'Pinnacle West Capital',
    value: 'join-paro-pinnacle-west-capital',
  },
  {
    label: 'Pioneer Natural Resources',
    value: 'join-paro-pioneer-natural-resources',
  },
  { label: 'Pitney Bowes', value: 'join-paro-pitney-bowes' },
  { label: 'Plains GP Holdings', value: 'join-paro-plains-gp-holdings' },
  { label: 'Plexus', value: 'join-paro-plexus' },
  {
    label: 'PNC Financial Services',
    value: 'join-paro-pnc-financial-services',
  },
  { label: 'Polaris Industries', value: 'join-paro-polaris-industries' },
  { label: 'PolyOne', value: 'join-paro-polyone' },
  { label: 'Pool', value: 'join-paro-pool' },
  { label: 'Popular', value: 'join-paro-popular' },
  {
    label: 'Portland General Electric',
    value: 'join-paro-portland-general-electric',
  },
  { label: 'Post Holdings', value: 'join-paro-post-holdings' },
  { label: 'PPG Industries', value: 'join-paro-ppg-industries' },
  { label: 'PPL', value: 'join-paro-ppl' },
  { label: 'PRA Health Sciences', value: 'join-paro-pra-health-sciences' },
  { label: 'Presidio', value: 'join-paro-presidio' },
  { label: 'PriceSmart', value: 'join-paro-pricesmart' },
  { label: 'Primoris Services', value: 'join-paro-primoris-services' },
  { label: 'Principal Financial', value: 'join-paro-principal-financial' },
  { label: 'Procter & Gamble', value: 'join-paro-procter-gamble' },
  { label: 'Progressive', value: 'join-paro-progressive' },
  { label: 'Prologis', value: 'join-paro-prologis' },
  { label: 'Prudential Financial', value: 'join-paro-prudential-financial' },
  {
    label: 'Public Service Enterprise Group',
    value: 'join-paro-public-service-enterprise-group',
  },
  { label: 'Public Storage', value: 'join-paro-public-storage' },
  { label: 'Publix Super Markets', value: 'join-paro-publix-super-markets' },
  { label: 'Puget Energy', value: 'join-paro-puget-energy' },
  { label: 'PulteGroup', value: 'join-paro-pultegroup' },
  { label: 'PVH', value: 'join-paro-pvh' },
  { label: 'Qorvo', value: 'join-paro-qorvo' },
  { label: 'Quad/Graphics', value: 'join-paro-quad/graphics' },
  { label: 'Qualcomm', value: 'join-paro-qualcomm' },
  { label: 'Quanta Services', value: 'join-paro-quanta-services' },
  { label: 'Quest Diagnostics', value: 'join-paro-quest-diagnostics' },
  { label: 'Qurate Retail', value: 'join-paro-qurate-retail' },
  { label: 'R.R. Donnelley & Sons', value: 'join-paro-r-r-donnelley-sons' },
  { label: 'Ralph Lauren', value: 'join-paro-ralph-lauren' },
  { label: 'Range Resources', value: 'join-paro-range-resources' },
  {
    label: 'Raymond James Financial',
    value: 'join-paro-raymond-james-financial',
  },
  {
    label: 'Rayonier Advanced Materials',
    value: 'join-paro-rayonier-advanced-materials',
  },
  { label: 'Raytheon', value: 'join-paro-raytheon' },
  { label: 'Realogy Holdings', value: 'join-paro-realogy-holdings' },
  { label: 'Red Hat', value: 'join-paro-red-hat' },
  { label: 'Regal Beloit', value: 'join-paro-regal-beloit' },
  {
    label: 'Regeneron Pharmaceuticals',
    value: 'join-paro-regeneron-pharmaceuticals',
  },
  { label: 'Regions Financial', value: 'join-paro-regions-financial' },
  {
    label: 'Reinsurance Group of America',
    value: 'join-paro-reinsurance-group-of-america',
  },
  {
    label: 'Reliance Steel & Aluminum',
    value: 'join-paro-reliance-steel-aluminum',
  },
  {
    label: 'Renewable Energy Group',
    value: 'join-paro-renewable-energy-group',
  },
  { label: 'Rent-A-Center', value: 'join-paro-rent-a-center' },
  { label: 'Republic Services', value: 'join-paro-republic-services' },
  { label: 'ResMed', value: 'join-paro-resmed' },
  {
    label: 'Resolute Forest Products',
    value: 'join-paro-resolute-forest-products',
  },
  { label: 'REV Group', value: 'join-paro-rev-group' },
  { label: 'Revlon', value: 'join-paro-revlon' },
  { label: 'Rexnord', value: 'join-paro-rexnord' },
  { label: 'RH', value: 'join-paro-rh' },
  { label: 'Rite Aid', value: 'join-paro-rite-aid' },
  {
    label: 'Roadrunner Transportation Systems',
    value: 'join-paro-roadrunner-transportation-systems',
  },
  {
    label: 'Robert Half International',
    value: 'join-paro-robert-half-international',
  },
  { label: 'Rockwell Automation', value: 'join-paro-rockwell-automation' },
  { label: 'Rockwell Collins', value: 'join-paro-rockwell-collins' },
  { label: 'Roper Technologies', value: 'join-paro-roper-technologies' },
  { label: 'Ross Stores', value: 'join-paro-ross-stores' },
  { label: 'RPM International', value: 'join-paro-rpm-international' },
  { label: 'Rush Enterprises', value: 'join-paro-rush-enterprises' },
  { label: 'Ryder System', value: 'join-paro-ryder-system' },
  { label: 'Ryerson Holding', value: 'join-paro-ryerson-holding' },
  { label: 'S&P Global', value: 'join-paro-sp-global' },
  { label: 'Sabre', value: 'join-paro-sabre' },
  { label: 'salesforce.com', value: 'join-paro-salesforce-com' },
  {
    label: 'Sally Beauty Holdings',
    value: 'join-paro-sally-beauty-holdings',
  },
  { label: 'Sanderson Farms', value: 'join-paro-sanderson-farms' },
  { label: 'Sanmina', value: 'join-paro-sanmina' },
  { label: 'SCANA', value: 'join-paro-scana' },
  { label: 'ScanSource', value: 'join-paro-scansource' },
  { label: 'Schneider National', value: 'join-paro-schneider-national' },
  {
    label: 'Schnitzer Steel Industries',
    value: 'join-paro-schnitzer-steel-industries',
  },
  {
    label: 'Science Applications International',
    value: 'join-paro-science-applications-international',
  },
  { label: 'Scientific Games', value: 'join-paro-scientific-games' },
  { label: 'Scotts Miracle-Gro', value: 'join-paro-scotts-miracle-gro' },
  { label: 'Seaboard', value: 'join-paro-seaboard' },
  { label: 'Sealed Air', value: 'join-paro-sealed-air' },
  {
    label: 'Securian Financial Group',
    value: 'join-paro-securian-financial-group',
  },
  {
    label: 'Select Medical Holdings',
    value: 'join-paro-select-medical-holdings',
  },
  {
    label: 'Selective Insurance Group',
    value: 'join-paro-selective-insurance-group',
  },
  { label: 'SemGroup', value: 'join-paro-semgroup' },
  { label: 'Sempra Energy', value: 'join-paro-sempra-energy' },
  {
    label: 'Sentry Insurance Group',
    value: 'join-paro-sentry-insurance-group',
  },
  {
    label: 'Service Corp. International',
    value: 'join-paro-service-corp-international',
  },
  { label: 'ServiceNow', value: 'join-paro-servicenow' },
  { label: 'Sherwin-Williams', value: 'join-paro-sherwin-williams' },
  { label: 'Shutterfly', value: 'join-paro-shutterfly' },
  { label: 'Silgan Holdings', value: 'join-paro-silgan-holdings' },
  { label: 'Simon Property Group', value: 'join-paro-simon-property-group' },
  {
    label: 'Sinclair Broadcast Group',
    value: 'join-paro-sinclair-broadcast-group',
  },
  {
    label: 'SiteOne Landscape Supply',
    value: 'join-paro-siteone-landscape-supply',
  },
  { label: 'Skechers U.S.A.', value: 'join-paro-skechers-u-s-a-' },
  { label: 'SkyWest', value: 'join-paro-skywest' },
  { label: 'Skyworks Solutions', value: 'join-paro-skyworks-solutions' },
  { label: 'SM Energy', value: 'join-paro-sm-energy' },
  { label: 'Smart & Final Stores', value: 'join-paro-smart-final-stores' },
  { label: 'Snap-on', value: 'join-paro-snap-on' },
  { label: 'Sonic Automotive', value: 'join-paro-sonic-automotive' },
  { label: 'Sonoco Products', value: 'join-paro-sonoco-products' },
  { label: 'Southern', value: 'join-paro-southern' },
  { label: 'Southwest Airlines', value: 'join-paro-southwest-airlines' },
  {
    label: 'Southwest Gas Holdings',
    value: 'join-paro-southwest-gas-holdings',
  },
  { label: 'Southwestern Energy', value: 'join-paro-southwestern-energy' },
  { label: 'SpartanNash', value: 'join-paro-spartannash' },
  {
    label: 'Spectrum Brands Holdings',
    value: 'join-paro-spectrum-brands-holdings',
  },
  { label: 'Spire', value: 'join-paro-spire' },
  {
    label: 'Spirit AeroSystems Holdings',
    value: 'join-paro-spirit-aerosystems-holdings',
  },
  { label: 'Spirit Airlines', value: 'join-paro-spirit-airlines' },
  { label: 'Sprague Resources', value: 'join-paro-sprague-resources' },
  {
    label: 'Sprouts Farmers Market',
    value: 'join-paro-sprouts-farmers-market',
  },
  { label: 'SPX FLOW', value: 'join-paro-spx-flow' },
  { label: 'Square', value: 'join-paro-square' },
  {
    label: 'SS&C Technologies Holdings',
    value: 'join-paro-ssc-technologies-holdings',
  },
  {
    label: 'Stanley Black & Decker',
    value: 'join-paro-stanley-black-decker',
  },
  { label: 'Starbucks', value: 'join-paro-starbucks' },
  { label: 'State Farm Insurance', value: 'join-paro-state-farm-insurance' },
  { label: 'State Street Corp.', value: 'join-paro-state-street-corp-' },
  { label: 'Steel Dynamics', value: 'join-paro-steel-dynamics' },
  { label: 'Steelcase', value: 'join-paro-steelcase' },
  { label: 'Stepan', value: 'join-paro-stepan' },
  { label: 'Stericycle', value: 'join-paro-stericycle' },
  { label: 'Stifel Financial', value: 'join-paro-stifel-financial' },
  { label: 'Stryker', value: 'join-paro-stryker' },
  { label: 'Summit Materials', value: 'join-paro-summit-materials' },
  { label: 'SunTrust Banks', value: 'join-paro-suntrust-banks' },
  {
    label: 'Superior Energy Services',
    value: 'join-paro-superior-energy-services',
  },
  { label: 'Supervalu', value: 'join-paro-supervalu' },
  { label: 'SVB Financial Group', value: 'join-paro-svb-financial-group' },
  { label: 'Symantec', value: 'join-paro-symantec' },
  { label: 'Synchrony Financial', value: 'join-paro-synchrony-financial' },
  { label: 'Syneos Health', value: 'join-paro-syneos-health' },
  { label: 'Synnex', value: 'join-paro-synnex' },
  { label: 'Synopsys', value: 'join-paro-synopsys' },
  { label: 'Sysco', value: 'join-paro-sysco' },
  { label: 'T. Rowe Price', value: 'join-paro-t-rowe-price' },
  { label: 'Tailored Brands', value: 'join-paro-tailored-brands' },
  { label: 'Tapestry', value: 'join-paro-tapestry' },
  { label: 'Targa Resources', value: 'join-paro-targa-resources' },
  { label: 'Target', value: 'join-paro-target' },
  { label: 'Taylor Morrison Home', value: 'join-paro-taylor-morrison-home' },
  {
    label: 'TD Ameritrade Holding',
    value: 'join-paro-td-ameritrade-holding',
  },
  { label: 'Tech Data', value: 'join-paro-tech-data' },
  { label: 'TEGNA', value: 'join-paro-tegna' },
  {
    label: 'Teledyne Technologies',
    value: 'join-paro-teledyne-technologies',
  },
  { label: 'Teleflex', value: 'join-paro-teleflex' },
  {
    label: 'Telephone & Data Systems',
    value: 'join-paro-telephone-data-systems',
  },
  {
    label: 'Tempur Sealy International',
    value: 'join-paro-tempur-sealy-international',
  },
  { label: 'Tenet Healthcare', value: 'join-paro-tenet-healthcare' },
  { label: 'Tenneco', value: 'join-paro-tenneco' },
  { label: 'Teradata', value: 'join-paro-teradata' },
  { label: 'Teradyne', value: 'join-paro-teradyne' },
  { label: 'Terex', value: 'join-paro-terex' },
  { label: 'Tesla', value: 'join-paro-tesla' },
  { label: 'Tetra Tech', value: 'join-paro-tetra-tech' },
  { label: 'Texas Instruments', value: 'join-paro-texas-instruments' },
  { label: 'Texas Roadhouse', value: 'join-paro-texas-roadhouse' },
  { label: 'Textron', value: 'join-paro-textron' },
  {
    label: 'Thermo Fisher Scientific',
    value: 'join-paro-thermo-fisher-scientific',
  },
  { label: 'Thor Industries', value: 'join-paro-thor-industries' },
  {
    label: 'Thrivent Financial for Lutherans',
    value: 'join-paro-thrivent-financial-for-lutherans',
  },
  { label: 'TIAA', value: 'join-paro-tiaa' },
  { label: 'Tiffany', value: 'join-paro-tiffany' },
  { label: 'Timken', value: 'join-paro-timken' },
  { label: 'TJX', value: 'join-paro-tjx' },
  { label: 'Toll Brothers', value: 'join-paro-toll-brothers' },
  { label: 'TopBuild', value: 'join-paro-topbuild' },
  { label: 'Torchmark', value: 'join-paro-torchmark' },
  { label: 'Toro', value: 'join-paro-toro' },
  {
    label: 'Total System Services',
    value: 'join-paro-total-system-services',
  },
  { label: 'Tower International', value: 'join-paro-tower-international' },
  { label: 'Tractor Supply', value: 'join-paro-tractor-supply' },
  { label: 'TransDigm Group', value: 'join-paro-transdigm-group' },
  { label: 'TransUnion', value: 'join-paro-transunion' },
  {
    label: 'TravelCenters of America',
    value: 'join-paro-travelcenters-of-america',
  },
  { label: 'Travelers', value: 'join-paro-travelers' },
  { label: 'TreeHouse Foods', value: 'join-paro-treehouse-foods' },
  { label: 'TRI Pointe Group', value: 'join-paro-tri-pointe-group' },
  { label: 'Tribune Media', value: 'join-paro-tribune-media' },
  { label: 'Trimble', value: 'join-paro-trimble' },
  { label: 'TriNet Group', value: 'join-paro-trinet-group' },
  { label: 'Trinity Industries', value: 'join-paro-trinity-industries' },
  { label: 'Triple-S Management', value: 'join-paro-triple-s-management' },
  { label: 'Triumph Group', value: 'join-paro-triumph-group' },
  { label: 'TrueBlue', value: 'join-paro-trueblue' },
  { label: 'TTM Technologies', value: 'join-paro-ttm-technologies' },
  { label: 'Tupperware Brands', value: 'join-paro-tupperware-brands' },
  { label: 'Tutor Perini', value: 'join-paro-tutor-perini' },
  {
    label: 'Twenty-First Century Fox',
    value: 'join-paro-twenty-first-century-fox',
  },
  { label: 'Twitter', value: 'join-paro-twitter' },
  { label: 'Tyson Foods', value: 'join-paro-tyson-foods' },
  { label: 'U.S. Bancorp', value: 'join-paro-u-s-bancorp' },
  { label: 'UGI', value: 'join-paro-ugi' },
  { label: 'Ulta Beauty', value: 'join-paro-ulta-beauty' },
  { label: 'Under Armour', value: 'join-paro-under-armour' },
  { label: 'Union Pacific', value: 'join-paro-union-pacific' },
  { label: 'Unisys', value: 'join-paro-unisys' },
  {
    label: 'United Continental Holdings',
    value: 'join-paro-united-continental-holdings',
  },
  { label: 'United Natural Foods', value: 'join-paro-united-natural-foods' },
  {
    label: 'United Parcel Service',
    value: 'join-paro-united-parcel-service',
  },
  { label: 'United Rentals', value: 'join-paro-united-rentals' },
  { label: 'United States Steel', value: 'join-paro-united-states-steel' },
  { label: 'United Technologies', value: 'join-paro-united-technologies' },
  { label: 'UnitedHealth Group', value: 'join-paro-unitedhealth-group' },
  { label: 'Univar', value: 'join-paro-univar' },
  { label: 'Universal', value: 'join-paro-universal' },
  {
    label: 'Universal Forest Products',
    value: 'join-paro-universal-forest-products',
  },
  {
    label: 'Universal Health Services',
    value: 'join-paro-universal-health-services',
  },
  {
    label: 'Univision Communications',
    value: 'join-paro-univision-communications',
  },
  { label: 'Unum Group', value: 'join-paro-unum-group' },
  { label: 'Urban Outfitters', value: 'join-paro-urban-outfitters' },
  { label: 'US Foods Holding', value: 'join-paro-us-foods-holding' },
  { label: 'USAA', value: 'join-paro-usaa' },
  { label: 'USG', value: 'join-paro-usg' },
  { label: 'Vail Resorts', value: 'join-paro-vail-resorts' },
  { label: 'Valero Energy', value: 'join-paro-valero-energy' },
  { label: 'Valmont Industries', value: 'join-paro-valmont-industries' },
  { label: 'Valvoline', value: 'join-paro-valvoline' },
  {
    label: 'Varian Medical Systems',
    value: 'join-paro-varian-medical-systems',
  },
  { label: 'Ventas', value: 'join-paro-ventas' },
  { label: 'Verisk Analytics', value: 'join-paro-verisk-analytics' },
  { label: 'Veritiv', value: 'join-paro-veritiv' },
  {
    label: 'Verizon Communications',
    value: 'join-paro-verizon-communications',
  },
  { label: 'Verso', value: 'join-paro-verso' },
  {
    label: 'Vertex Pharmaceuticals',
    value: 'join-paro-vertex-pharmaceuticals',
  },
  { label: 'VF', value: 'join-paro-vf' },
  { label: 'Viacom', value: 'join-paro-viacom' },
  { label: 'Visa', value: 'join-paro-visa' },
  {
    label: 'Vishay Intertechnology',
    value: 'join-paro-vishay-intertechnology',
  },
  { label: 'Vista Outdoor', value: 'join-paro-vista-outdoor' },
  { label: 'Visteon', value: 'join-paro-visteon' },
  { label: 'Vistra Energy', value: 'join-paro-vistra-energy' },
  { label: 'Vornado Realty Trust', value: 'join-paro-vornado-realty-trust' },
  { label: 'Voya Financial', value: 'join-paro-voya-financial' },
  { label: 'Vulcan Materials', value: 'join-paro-vulcan-materials' },
  { label: 'W.R. Berkley', value: 'join-paro-w-r-berkley' },
  { label: 'W.W. Grainger', value: 'join-paro-w-w-grainger' },
  { label: 'Wabash National', value: 'join-paro-wabash-national' },
  { label: 'WABCO Holdings', value: 'join-paro-wabco-holdings' },
  {
    label: 'Walgreens Boots Alliance',
    value: 'join-paro-walgreens-boots-alliance',
  },
  { label: 'Walmart', value: 'join-paro-walmart' },
  { label: 'Walt Disney', value: 'join-paro-walt-disney' },
  { label: 'Warner Music Group', value: 'join-paro-warner-music-group' },
  { label: 'Waste Management', value: 'join-paro-waste-management' },
  { label: 'Waters', value: 'join-paro-waters' },
  { label: 'Watsco', value: 'join-paro-watsco' },
  { label: 'Wayfair', value: 'join-paro-wayfair' },
  { label: 'WEC Energy Group', value: 'join-paro-wec-energy-group' },
  { label: 'Weis Markets', value: 'join-paro-weis-markets' },
  {
    label: 'WellCare Health Plans',
    value: 'join-paro-wellcare-health-plans',
  },
  { label: 'Wells Fargo', value: 'join-paro-wells-fargo' },
  { label: 'Welltower', value: 'join-paro-welltower' },
  { label: 'Werner Enterprises', value: 'join-paro-werner-enterprises' },
  { label: 'WESCO International', value: 'join-paro-wesco-international' },
  {
    label: 'Western & Southern Financial Group',
    value: 'join-paro-western-southern-financial-group',
  },
  { label: 'Western Digital', value: 'join-paro-western-digital' },
  { label: 'Western Union', value: 'join-paro-western-union' },
  {
    label: 'Westinghouse Air Brake',
    value: 'join-paro-westinghouse-air-brake',
  },
  { label: 'Westlake Chemical', value: 'join-paro-westlake-chemical' },
  { label: 'WestRock', value: 'join-paro-westrock' },
  { label: 'Weyerhaeuser', value: 'join-paro-weyerhaeuser' },
  { label: 'WGL Holdings', value: 'join-paro-wgl-holdings' },
  { label: 'Whirlpool', value: 'join-paro-whirlpool' },
  { label: 'Whiting Petroleum', value: 'join-paro-whiting-petroleum' },
  { label: 'William Lyon Homes', value: 'join-paro-william-lyon-homes' },
  { label: 'Williams', value: 'join-paro-williams' },
  { label: 'Williams-Sonoma', value: 'join-paro-williams-sonoma' },
  { label: 'Windstream Holdings', value: 'join-paro-windstream-holdings' },
  { label: 'Winnebago Industries', value: 'join-paro-winnebago-industries' },
  { label: 'Wolverine World Wide', value: 'join-paro-wolverine-world-wide' },
  { label: 'Woodward', value: 'join-paro-woodward' },
  { label: 'Workday', value: 'join-paro-workday' },
  { label: 'World Fuel Services', value: 'join-paro-world-fuel-services' },
  { label: 'Worldpay', value: 'join-paro-worldpay' },
  {
    label: 'Worthington Industries',
    value: 'join-paro-worthington-industries',
  },
  { label: 'WPX Energy', value: 'join-paro-wpx-energy' },
  { label: 'Wyndham Destinations', value: 'join-paro-wyndham-destinations' },
  { label: 'Wynn Resorts', value: 'join-paro-wynn-resorts' },
  { label: 'Xcel Energy', value: 'join-paro-xcel-energy' },
  { label: 'Xerox', value: 'join-paro-xerox' },
  { label: 'Xilinx', value: 'join-paro-xilinx' },
  { label: 'XPO Logistics', value: 'join-paro-xpo-logistics' },
  { label: 'Xylem', value: 'join-paro-xylem' },
  { label: 'YRC Worldwide', value: 'join-paro-yrc-worldwide' },
  { label: 'Yum Brands', value: 'join-paro-yum-brands' },
  { label: 'Yum China Holdings', value: 'join-paro-yum-china-holdings' },
  { label: 'Zayo Group Holdings', value: 'join-paro-zayo-group-holdings' },
  { label: 'Zebra Technologies', value: 'join-paro-zebra-technologies' },
  {
    label: 'Zimmer Biomet Holdings',
    value: 'join-paro-zimmer-biomet-holdings',
  },
  { label: 'Zions Bancorp.', value: 'join-paro-zions-bancorp-' },
  { label: 'Zoetis', value: 'join-paro-zoetis' },
  { label: 'Other', value: 'other' },
  { label: 'Becker', value: 'join-paro-becker' },
  { label: 'Ladders', value: 'join-paro-ladders' },
  { label: 'CPADirectory', value: 'join-paro-cpa-directory' },
  { label: 'Going Concern', value: 'join-paro-going-concern' },
  { label: 'myCPE', value: 'mycpe' },
  { label: 'CPEThink', value: 'cpethink' },
  { label: 'CFO Dive', value: 'join-paro-cfo-dive' },
]
